import { DomSanitizer } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Component, Input, OnInit } from "@angular/core";
import { NgForm, FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import Swal from "sweetalert2";

import { SharedDataService } from "@teem/services/shared-data.service";
import { LoaderService } from "@teem/services/loader.service";
import { messages as i18n } from "@teem/constants/messages";
import { country as CountryApi } from "@teem/constants/api";
import { UserService } from "@teem/services/user.service";
import * as COUNTRIES from "@teem/constants/country";

@Component({
  selector: "business-information",
  templateUrl: "./business-information.component.html",
  styleUrls: ["./business-information.component.css"]
})
export class BusinessInformationComponent implements OnInit {
  userDetails: any;
  businessForm: any = {};
  businessFormGroup: FormGroup;
  businessFormSubmit: boolean = false;
  additionalInfoSubmit = false;
  additionalInformationForm: any = {};
  additionalInformationFormGroup:FormGroup;
  isDisable = false;
  countryListApi: string = CountryApi.endPoint;
  selectedCountry: any;
  locale: string = 'en';
  tapCountries: any = COUNTRIES.TAP_ACTIVE_COUNTRY;

  @Input("userDetails")
  set getInfo(val: any) {
    this.userDetails = val;
    this.businessForm = Object.assign({}, val);
    if (
      this.userDetails &&
      this.userDetails.setting &&
      this.userDetails.setting.additional_info
    )
      this.additionalInformationForm.additional_info = this.userDetails.setting.additional_info;

    if (this.userDetails.country_id && this.userDetails.country_name) {
      this.selectedCountry = {
        id: this.userDetails.country_id,
        country_name: this.userDetails.country_name
      };
    }

    if (this.userDetails.tax_percent) {
      this.businessForm.include_tax = true;
      this.businessForm.tax_percent = this.userDetails.tax_percent;
      this.enableTax(false);
    }
    this.initBusinessForm();
    this.initAdditionalInfoForm();
  }

  constructor(
    private loaderService: LoaderService,
    private userService: UserService,
    private sharedDataService: SharedDataService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.locale = (window as any).LOCALE;
    this.initBusinessForm();
    this.initAdditionalInfoForm();
  }

  initBusinessForm() {
    this.businessFormGroup = this.fb.group({
      address1: [this.businessForm?.address1],
      country_id: [this.businessForm?.country_id],
      include_tax: [this.businessForm?.include_tax],
      tax_percent: [this.businessForm?.tax_percent],
      tax_number: [this.businessForm?.tax_number],
      cr_number: [this.businessForm?.cr_number]
    });
  }

  initAdditionalInfoForm() {
    this.additionalInformationFormGroup = this.fb.group({
      additional_info: [this.additionalInformationForm.additional_info]
    });
  }

  onCountryChange(event: any, form: NgForm) {
    // form.controls.country_id.setValue(event.target.value.split(':').pop().trim());
    // this.businessForm.country_id = event.target.value;
  }

  enableTax(value: boolean) {
    if (value) {
      this.isDisable = false;
      this.businessFormGroup.get("tax_percent").setValue(null);
      this.businessFormGroup.get("tax_percent").clearValidators();
      this.businessFormGroup.get("tax_percent").updateValueAndValidity();

      this.businessFormGroup.get("tax_number").setValue(null);
      this.businessFormGroup.get("tax_number").clearValidators();
      this.businessFormGroup.get("tax_number").updateValueAndValidity();

      // this.businessFormGroup.get("address1").setValue(null);
      this.businessFormGroup.get("address1").clearValidators();
      this.businessFormGroup.get("address1").updateValueAndValidity();
    } else {
      this.isDisable = true;
      this.businessFormGroup.get("tax_percent").setValidators([Validators.required]);
      this.businessFormGroup.get("address1").setValidators([Validators.required]);
      this.businessFormGroup.get("tax_number").setValidators([Validators.required]);
      this.businessFormGroup.get("tax_percent").updateValueAndValidity();
      this.businessFormGroup.get("address1").updateValueAndValidity();
      this.businessFormGroup.get("tax_number").updateValueAndValidity();
    }
  }

  onSubmit() {
    this.businessFormSubmit = true;
    if (this.businessFormGroup.valid) {
      let fd = this.businessFormGroup.value;
      this.saveData();

      // // Check country change // To-Dp: Uncomment when Payment gateway active
      // if (
      //   !this.tapCountries.includes(fd.country_id)
      //   // this.userDetails.country_id == COUNTRIES.SAUDI_ARABIA &&
      //   // this.userDetails.country_id != fd.country_id
      // ) {
      //   Swal.fire({
      //     title: i18n.warning,
      //     text: i18n.setting.online_payment_not_available_for_country,
      //     icon: "warning",
      //     showCloseButton: true,
      //     showCancelButton: true,
      //     focusConfirm: false,
      //     confirmButtonText: i18n.ok,
      //     cancelButtonText: i18n.cancel
      //   }).then(result => {
      //     if (result.value) {
      //       this.saveData();
      //     }
      //   });
      // } else {
      //   this.saveData();
      // }
    }
  }

  saveData() {
    this.loaderService.startLoading();

    let fd = this.businessFormGroup.value;
    this.userService
      .updateBusinessInfo(fd, {
        headers: { "Content-Type": "multipart/form-data" }
      })
      .subscribe(
        (res: any) => {
          this.loaderService.stopLoading();

          Object.assign(this.userDetails, this.businessForm);
          Object.assign(this.userDetails, res.data);
          Object.assign((window as any).userInfo, res.data);

          // let fd = this.accountSettingForm.value;
          let user = this.sharedDataService.getItem("userInfo");
          Object.assign(user, res.data);
          this.sharedDataService.setItem("userInfo", user);

          this.userDetails.setting.additional_info = this.businessForm.setting.additional_info;
          // Here we are updating user other information and image variable
          //  Also need to update user avatar here
          Swal.fire(
            i18n.done,
            i18n.setting.business_information_updated,
            "success"
          );
        },
        err => {
          this.loaderService.stopLoading();
          // Set server side error
          if (err.status === 422) {
            if (
              err.error &&
              err.error.errors &&
              Object.keys(err.error.errors).length
            ) {
              let validationErrors = err.error.errors;
              Object.keys(validationErrors).forEach(prop => {
                this.businessFormGroup.controls[prop]?.setErrors({
                  serverError: validationErrors[prop]
                });
              });
            }
          }

          Swal.fire(i18n.alert.error, i18n.getError(err), "error");
        }
      );
  }

  saveAdditionalInfo() {
    // this.loaderService.startLoading();
    this.additionalInfoSubmit = true;
    if (this.additionalInformationFormGroup.valid) {
      let fd = this.additionalInformationFormGroup.value;
      this.loaderService.startLoading();
      this.userService.updateBusinessInfo(fd).subscribe(
        (res: any) => {
          this.loaderService.stopLoading();
          Object.assign((window as any).userInfo, res.data);

          // let fd = this.accountSettingForm.value;
          let user = this.sharedDataService.getItem("userInfo");

          this.sharedDataService.setItem("userInfo", user);
          //  Also need to update user avatar here
          Swal.fire(
            i18n.done,
            i18n.setting.business_information_updated,
            "success"
          );
        },
        err => {
          this.additionalInfoSubmit = false;
          this.loaderService.stopLoading();
          // Set server side error
          if (err.status === 422) {
            if (
              err.error &&
              err.error.errors &&
              Object.keys(err.error.errors).length
            ) {
              let validationErrors = err.error.errors;
              Object.keys(validationErrors).forEach(prop => {
                this.additionalInformationFormGroup.controls[prop]?.setErrors({
                  serverError: validationErrors[prop]
                });
              });
            }
          }

          Swal.fire(i18n.alert.error, i18n.getError(err), "error");
        }
      );
    }
  }
}
